import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class AddInventarisTerm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prosesSimpan: false,
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleAdd = () => {
        this.setState({ prosesSimpan: true})
        let form = {
            karyawan_id : this.props.data.karyawan_selected?.value,
            inventaris_id : this.props.data.inventaris_selected?.value,
            tanggal_pengajuan : this.props.data.tanggal_pengajuan,
            pengajuan_desc : this.props.data.pengajuan_desc,
        }
        this.props.request("pengajuan_inventaris/add", form, 'POST')
            .then((response) => {
                if (response && response.success) {
                    this.props.changeState({
                        modal_add: false,
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon:'success',
                        confirmButtonText: 'OK'
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({ prosesSimpan: false})
                this.props.clear()
            })
    }

    render() {
        return (
            <Modal isOpen={this.props.modal_add} toggle={this.props.clear} style={{ maxWidth: "1000px"}} zIndex={999}>
                <ModalHeader className="modal-header-ipresens" toggle={this.props.clear}>
                    <div className='modal-header-ipresens'>Tambah Pengajuan Inventaris</div>
                </ModalHeader>
                <ModalBody className="inventaris-modal-body">
                    <div className="row p-3">
                        <div className="col">
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "namaKaryawanPengajuanInv",
                                        title: "Nama Karyawan",
                                        content: "Pilih nama karyawan yang akan mengajukan permintaan inventaris. Ketik untuk mencari karyawan."
                                    });
                                }}>
                                <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                    Nama Karyawan
                                </label>
                                <Select
                                    placeholder="Nama karyawan"
                                    backspaceRemoves={true} deleteRemoves={true}
                                    styles={{paddingLeft: "0px", fontSize: "12px"}}
                                    components={{DropdownIndicator: () => null, IndicatorSeparator: () => null}}
                                    value={this.props.data.karyawan_selected}
                                    options={this.props.data.karyawan?.map((item) => ({
                                        value: item.karyawan_id,
                                        label: item.karyawan_nama,
                                    })) || []}
                                    onChange={(karyawan_selected) => {
                                        if (!karyawan_selected) {
                                            this.props.changeState({
                                                karyawan_selected: '',
                                            });
                                        } else {
                                            this.props.changeState({
                                                karyawan_selected,
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "inventarisPengajuanInv",
                                        title: "Inventaris",
                                        content: "Pilih nama inventaris yang ingin diajukan oleh karyawan. Ketik untuk mencari inventaris."
                                    });
                                }}>
                                <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                    Inventaris
                                </label>
                                <Select
                                    placeholder="Nama invenatris"
                                    backspaceRemoves={true} deleteRemoves={true}
                                    styles={{paddingLeft: "0px", fontSize: "12px"}}
                                    components={{DropdownIndicator: () => null, IndicatorSeparator: () => null}}
                                    value={this.props.data.inventaris_selected}
                                    options={this.props.data.inventaris?.map((item) => ({
                                        value: item.inventaris_id,
                                        label: item.inventaris_name,
                                    })) || []}
                                    onChange={(inventaris_selected) => {
                                        if (!inventaris_selected) {
                                            this.props.changeState({
                                                inventaris_selected: '',
                                            });
                                        } else {
                                            this.props.changeState({
                                                inventaris_selected,
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="pengumuman-label-input">
                                    Tanggal Pengajuan
                                </label>
                                <input
                                    type="date"
                                    onChange={this.props.handleChange}
                                    className="form-control"
                                    name='tanggal_pengajuan'
                                    value={this.props.data.tanggal_pengajuan}
                                    placeholder="pilih tanggal"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "tanggalPengajuanInv",
                                            title: "Tanggal Pengajuan",
                                            content: "Pilih tanggal pengajuan inventaris yang diinginkan oleh karyawan."
                                        });
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="pengumuman-label-input">
                                    Keterangan
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="keterangan"
                                    onChange={this.props.handleChange}
                                    name='pengajuan_desc'
                                    value={this.props.data.pengajuan_desc}
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "keteranganPengajuanInv",
                                            title: "Keterangan",
                                            content: "Masukkan keterangan atau alasan pengajuan inventaris oleh karyawan."
                                        });
                                    }}>
                </textarea>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="inventaris-modal-footer">
                    <button onClick={this.props.clear}
                            className='btn text-capitalize batalkan-add-jamker'>Batal</button>
                    <button className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
                            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            onClick={this.handleAdd}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(AddInventarisTerm);